(function($){

    // capital city center when geolocation is off
    const defaultCoordinates = {
        'gr': {
            'latitude': 37.9838,
            'longitude': 23.7275,
        },
        'nl': {
            'latitude': 52.3676,
            'longitude': 4.9041,
        },
        'si': {
            'latitude': 46.0569,
            'longitude': 14.5058,
        },
        'bg': {
            'latitude': 42.6977,
            'longitude': 23.3219,
        },
    }
    // translations must be supplied explicitly, there is no language parameter
    const translations = {
        'cs': {
            "enter_location": "zadejte polohu",
            "monday": "pondělí:",
            "tuesday": "úterý:",
            "wednesday": "středa:",
            "thursday": "čtvrtek:",
            "friday": "pátek:",
            "saturday": "sobota:",
            "sunday": "neděle:",
            "navigate_to_location": "navigovat na místo",
            "pickup_here": "vyzvednu zde",
            "more_info": "více info",
            "type_of_delivery": "TYP VÝDEJNÍHO MÍSTA:",
            "type_of_delivery_parcelbox": "parcelbox",
            "type_of_delivery_parcelshop": "parcelshop",
            "type_of_delivery_post": "pošta",
            "payment_method": "PLATEBNÍ METODY:",
            "payment_method_cash": "hotovost",
            "payment_method_card": "platební karta",
            "payment_method_app": "aplikace",
            "opening_hours": "OTEVÍRACÍ DOBA:",
            "opening_hours_title": "Otevírací doba",
            "opening_hours_nonstop": "nonstop",
            "opening_hours_opening": "pevná",
            "parcelshop_not_found_heading": "V okolí nenalezeny žádné parcelshopy.",
            "parcelshop_not_found_info": "Změňte adresu nebo lokalitu v mapě"
        },
        'gr': {
            "enter_location": "Εισάγετε τοποθεσία",
            "monday": "Δευτέρα:",
            "tuesday": "Τρίτη:",
            "wednesday": "Τετάρτη:",
            "thursday": "Πέμπτη:",
            "friday": "Παρασκευή:",
            "saturday": "Σάββατο:",
            "sunday": "Κυριακή:",
            "navigate_to_location": "Πλοήγηση στην τοποθεσία",
            "pickup_here": "Παραλαβή εδώ",
            "more_info": "Περισσότερες πληροφορίες",
            "type_of_delivery": "ΤΥΠΟΣ ΣΗΜΕΙΟΥ ΠΑΡΑΛΑΒΗΣ:",
            "type_of_delivery_parcelbox": "Parcelbox",
            "type_of_delivery_parcelshop": "Parcelshop",
            "type_of_delivery_post": "Ταχυδρομείο",
            "payment_method": "ΜΕΘΟΔΟΙ ΠΛΗΡΩΜΗΣ:",
            "payment_method_cash": "Μετρητά",
            "payment_method_card": "Πιστωτική κάρτα",
            "payment_method_app": "Εφαρμογή",
            "opening_hours": "ΩΡΑΡΙΟ ΛΕΙΤΟΥΡΓΙΑΣ:",
            "opening_hours_title": "Ωράριο λειτουργίας",
            "opening_hours_nonstop": "Nonstop",
            "opening_hours_opening": "Σταθερό",
            "parcelshop_not_found_heading": "Δεν βρέθηκαν parcelshopy στην περιοχή.",
            "parcelshop_not_found_info": "Αλλάξτε τη διεύθυνση ή την τοποθεσία στον χάρτη"
        },
        'nl': {
            "enter_location": "Voer locatie in",
            "monday": "Maandag:",
            "tuesday": "Dinsdag:",
            "wednesday": "Woensdag:",
            "thursday": "Donderdag:",
            "friday": "Vrijdag:",
            "saturday": "Zaterdag:",
            "sunday": "Zondag:",
            "navigate_to_location": "Navigeer naar locatie",
            "pickup_here": "Hier ophalen",
            "more_info": "Meer info",
            "type_of_delivery": "TYPE AFHAALPUNT:",
            "type_of_delivery_parcelbox": "Parcelbox",
            "type_of_delivery_parcelshop": "Parcelshop",
            "type_of_delivery_post": "Postkantoor",
            "payment_method": "BETAALMETHODEN:",
            "payment_method_cash": "Contant",
            "payment_method_card": "Betaalkaart",
            "payment_method_app": "Applicatie",
            "opening_hours": "OPENINGSTIJDEN:",
            "opening_hours_title": "Openingstijden",
            "opening_hours_nonstop": "Nonstop",
            "opening_hours_opening": "Vast",
            "parcelshop_not_found_heading": "Geen parcelshops gevonden in de buurt.",
            "parcelshop_not_found_info": "Wijzig het adres of de locatie op de kaart"
        },
        'si': {
            "enter_location": "vnesite lokacijo",
            "monday": "ponedeljek:",
            "tuesday": "torek:",
            "wednesday": "sreda:",
            "thursday": "četrtek:",
            "friday": "petek:",
            "saturday": "sobota:",
            "sunday": "nedelja:",
            "navigate_to_location": "navigiraj do lokacije",
            "pickup_here": "prevzamem tukaj",
            "more_info": "več info",
            "type_of_delivery": "VRSTA PREVZEMNEGA MESTA:",
            "type_of_delivery_parcelbox": "paketomat",
            "type_of_delivery_parcelshop": "parcelshop",
            "type_of_delivery_post": "pošta",
            "payment_method": "NAČINI PLAČILA:",
            "payment_method_cash": "gotovina",
            "payment_method_card": "plačilna kartica",
            "payment_method_app": "aplikacija",
            "opening_hours": "DELOVNI ČAS:",
            "opening_hours_title": "Delovni čas",
            "opening_hours_nonstop": "nonstop",
            "opening_hours_opening": "fiksen",
            "parcelshop_not_found_heading": "V bližini ni bilo najdenih parcelshopov.",
            "parcelshop_not_found_info": "Spremenite naslov ali lokacijo na zemljevidu"
        },
        'bg': {
            "enter_location": "въведете местоположение",
            "monday": "понеделник:",
            "tuesday": "вторник:",
            "wednesday": "сряда:",
            "thursday": "четвъртък:",
            "friday": "петък:",
            "saturday": "събота:",
            "sunday": "неделя:",
            "navigate_to_location": "навигиране до мястото",
            "pickup_here": "ще взема оттук",
            "more_info": "повече информация",
            "type_of_delivery": "ТИП ОБЕКТ ЗА ПОЛУЧАВАНЕ:",
            "type_of_delivery_parcelbox": "автомат за пратки",
            "type_of_delivery_parcelshop": "офис за пратки",
            "type_of_delivery_post": "поща",
            "payment_method": "НАЧИНИ НА ПЛАЩАНЕ:",
            "payment_method_cash": "в брой",
            "payment_method_card": "банкова карта",
            "payment_method_app": "приложение",
            "opening_hours": "РАБОТНО ВРЕМЕ:",
            "opening_hours_title": "Работно време",
            "opening_hours_nonstop": "денонощно",
            "opening_hours_opening": "фиксирано",
            "parcelshop_not_found_heading": "В района не са намерени офиси за пратки.",
            "parcelshop_not_found_info": "Променете адреса или местоположението на картата"
        },
    }

    let country

	let $form = $("form.checkout_form"),
		$shipping_fields = $form.find(".woocommerce-shipping-fields")

    // Hide shipping fields on page load when a custom shipping method is selected
    let selected_method = $form.find("input[name='shipping_method']:checked")
    if (selected_method && selected_method.data("method-id") !== 'custom'){
        $shipping_fields.hide()
    }

	$(document).gp_ready(function(){

		// Open widget on shipping method change to "posta_bez_hranic"
		$form.find("input[name='shipping_method']").change(function(){
			let method_id = $(this).data("method-id")
			if(method_id === "posta_bez_hranic"){
				// Open widget
				open_widget()
				// Hide shipping address fields
				$shipping_fields.hide()
			}else if (method_id === "custom"){
				// Close widget
				close_widget()
				// Show shipping address fields
				$shipping_fields.show()
			}
		})

		// Open widget on choose button click
		$form.find('.pbh_select-btn').off("click").click(function(){
			$('.pbh_select-btn').addClass('loading')
			setTimeout(function(){
				$('.pbh_select-btn').removeClass('loading')
			}, 3000)

			open_widget()
		})

		//  Display chosen branch
		update_data_from_session()

	})

	function open_widget(){

		country = $form.find("select[name='billing_country'], input[name='billing_country']").val()
		if(!country){
			alert("Country not selected.")
			return
		}
        country = country.toLowerCase()

        let pickMappConfig = {
            'mapElementId': "pickMapp",
            "api_key": posta_bez_hranic_widget_params.posta_bez_hranic_api_key,
            'googleApiKey': posta_bez_hranic_widget_params.google_api_key,
            "countries": [country],
            "afterParcelshopSelectCallback": widget_callback,
            "translations": translations[country],
            'defaultLlatitude': defaultCoordinates[country].latitude,
            'defaultLlongitude': defaultCoordinates[country].longitude,
            'parcelshops': [ // more here: https://apidoc.postabezhranic.cz/en/pbh/general#static-list-of-couriers and https://docs.google.com/spreadsheets/d/18KXeJ--l-9e8AGpmnriScl1UBmXWUf-OdlGhNDLoO7s/edit?usp=sharing (might have wrong ID)
                {
                    'number': 178,
                    'filterName': 'BOX NOW',
                    'filterColor': '#45D62C',
                    'deliveryPrice': '',
                    'active': country === 'gr' ? 1 : 0,
                },
                {
                    'number': 234,
                    'filterName': 'PostNL',
                    'filterColor': '#F56802',
                    'deliveryPrice': '',
                    'active': country === 'nl' ? 1 : 0,
                },
                {
                    'number': 185,
                    'filterName': 'Pošta Slovenije',
                    'filterColor': '#FFDA56',
                    'deliveryPrice': '',
                    'active': country === 'si' ? 1 : 0,
                },
                {
                    'number': 251,
                    'filterName': 'Speedy',
                    'filterColor': '#D20F37',
                    'deliveryPrice': '',
                    'active': country === 'bg' ? 1 : 0,
                },
            ]
        }

		// Open widget
        const modal = $('.pbh_select.modal')
        modal.addClass('modal--open')

        pickmappInit(pickMappConfig)
	}

	// Close
	function close_widget(){
        const modal = $('.pbh_select.modal')
        modal.removeClass('modal--open')
	}

	function widget_callback(parcelshopNumber, courierNumber, name, address, city, zip) {
        let address_split = splitPickupAddress(address, city, zip)

        let locationData = {
            "address_full": `${address_split.address_1} ${address_split.address_2}`.trim(),
            "address_1": address_split.address_1,
            "address_2": address_split.address_2,
            city,
            country,
            zip,
            name,
            "id": parcelshopNumber,
        }

        fill_inputs(locationData)

        sessionStorage.setItem( "gp_pbh_branch_info", JSON.stringify(locationData) )

        display_chosen_pickup_point(locationData)

        close_widget()
	}

    function fill_inputs(locationData){
        jQuery("input[name='pbh_shipping_address_1']").val(locationData.address_1)
        jQuery("input[name='pbh_shipping_address_2']").val(locationData.address_2)
        jQuery("input[name='pbh_shipping_city']").val(locationData.city)
        jQuery("input[name='pbh_shipping_company']").val(locationData.name)
        jQuery("input[name='pbh_shipping_country']").val(locationData.country)
        jQuery("input[name='pbh_shipping_postcode']").val(locationData.zip)
        jQuery("input[name='pbh_branch_id']").val(locationData.id)
    }

	function display_chosen_pickup_point(locationData){

		// Change button text
        const btn = $form.find("a.pbh_select-btn")
        if (btn){
            btn.text(btn.data('label-change'))
        }

		// Display address
		$form.find(".pbh_branch").show()
		let addressOutput = `${locationData.name}<br>${locationData.address_full}<br>${locationData.zip}, ${locationData.city}`
		$form.find("p#pbh_branch-address").html(addressOutput)
	}

	function update_data_from_session(){

		let locationData = sessionStorage.getItem("gp_pbh_branch_info")
		if(!locationData){
			return
		}

		locationData = JSON.parse(locationData)
		fill_inputs(locationData)
        display_chosen_pickup_point(locationData)
	}

    // The address is usually a combination of street and property number, some companies include the entire address there
    function splitPickupAddress(address, city, zip) {
        const escapeRegex = (s) => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')

        let addr = address.trim()

        // Removes city and zip, if included in the address string
        for (const token of [zip, city].filter(Boolean)) {
            addr = addr
                    .replace(new RegExp(',?\\s*' + escapeRegex(token.trim()) + '\\s*,?', 'i'), '')
                    .trim()
        }

        // Trim leftover whitespace and commas
        addr = addr.replace(/^[,\s]+|[,\s]+$/g, '').replace(/\s{2,}/g, ' ')

        // Trailing number: "Street 12a"
        const trailingNumber = addr.match(/^(.+?)\s+(\d+\w*(?:\/\w+)?)$/)
        if (trailingNumber) {
            return {
                address_1: trailingNumber[1].trim(),
                address_2: trailingNumber[2].trim(),
            }
        }

        // Leading number: "12 Main Street"
        const leadingNumber = addr.match(/^(\d+\w*(?:\/\w+)?)\s+(.+)$/)
        if (leadingNumber) {
            return {
                address_1: leadingNumber[2].trim(),
                address_2: leadingNumber[1].trim(),
            }
        }

        // Can't split - put everything in address_1
        return { address_1: addr, address_2: '' }
    }

})(jQuery)
